import common from './common.json'
import components from './components.json'
import navigation from './navigation.json'
import auth from './auth.json'
import dashboard from './dashboard.json'
import expenses from './expenses.json'
import income from './income.json'
import taxes from './taxes.json'
import kyc from './kyc.json'
import profile from './profile.json'
import validation from './validation.json'
import welcome from './welcome.json'
import bolt from './bolt.json'
import uber from './uber.json'
import handbook from './handbook.json'
import tours from './tours.json'
import calculator from './calculator.json'

export default {
  common,
  components,
  navigation,
  auth,
  dashboard,
  expenses,
  income,
  taxes,
  kyc,
  profile,
  validation,
  welcome,
  bolt,
  uber,
  handbook,
  tours,
  calculator,
}
